import Settings from './Setting';
import CommonReducer from './CommonReducer';
import Auth from './Auth';
import Credit from './Credit';

const reducers = {
  settings: Settings,
  auth: Auth,
  common: CommonReducer,
  credit: Credit,
};

export default reducers;
